import { useContext } from "react";
import UserContext from "../Contexts/UserContext";
import EmployeeTimesheets from "./EmployeeTimesheets";
import ManagerTimesheets from "./ManagerTimesheets";

export const Timesheets = () => {
  const { user } = useContext(UserContext);

  if (
    user.Role === "manager" ||
    user.Role === "hiring manager" ||
    user.Role === "tgs-admin" ||
    user.Role === "admin"
  ) {
    return <ManagerTimesheets />;
  } else {
    return <EmployeeTimesheets />;
  }
};